import has from 'lodash/has';
import * as types from '../../constants/actionTypes';
import { authFetch, cacheExpiration } from '../../api';
import { normalize } from 'normalizr';
import { addEntities } from '../../actions/entities';
import cache from 'memory-cache';

const cacheKey = 'admin_notifications';

const request = () => ({
	type: types.ADMIN_NOTIFICATIONS_FETCH_REQUEST,
});

const success = notifications => ({
	type: types.ADMIN_NOTIFICATIONS_FETCH_SUCCESS,
	payload: {
		notifications,
	},
});

const failure = message => ({
	type: types.ADMIN_NOTIFICATIONS_FETCH_FAILURE,
	payload: {
		message,
	},
});

const defaultOptions = {
	ignoreCache: false,
	filters: [],
};

export default function get(inputOptions = {}) {
	return (dispatch, getState, { schema }) => {
		const options = { ...defaultOptions, ...inputOptions };
		const state = getState();
		const { token, isAuthenticated } = state.auth;

		if (!isAuthenticated) return;

		if (!options.ignoreCache && cache.get(cacheKey)) return;

		const params = options.filters.length
			? 'filters=' + options.filters.join('&')
			: '';

		dispatch(request());

		authFetch(`admin-notifications?${params}`, {}, token, dispatch)
			.then(res => res.json())
			.then(res => {
				if (!has(res, 'admin_notifications')) {
					return has(res, 'error')
						? dispatch(failure(res.error))
						: dispatch(failure('Something went wrong.'));
				}

				const data = normalize(res.admin_notifications, [
					schema.adminNotification,
				]);
				dispatch(addEntities(data.entities));
				dispatch(success(data.entities.adminNotifications));
				return cache.put(cacheKey, true, cacheExpiration);
			})
			.catch(error => dispatch(failure(error.message || error)));
	};
}



// WEBPACK FOOTER //
// ./src/actions/adminNotifications/getAdminNotifications.js